/* Preserve Searchanise's own UI, with a click/pointer fallback for mobile Safari. */
(function () {
  'use strict';
  if (window.m21MobileSearchBound) return;
  window.m21MobileSearchBound = true;
  var pending = null;
  var timer = null;

  function cancel() {
    clearTimeout(timer);
    timer = null;
    pending = null;
  }

  function open(input, attempt) {
    if (pending !== input || !input.isConnected || !input.getClientRects().length || document.hidden) {
      cancel();
      return;
    }
    var search = window.Searchanise;
    var field = search && typeof search.$ === 'function' ? search.$(input) : null;
    var autocomplete = field && field.data('autocompleter');
    if (!autocomplete || !autocomplete.select) {
      if (attempt < 15) timer = setTimeout(function () { open(input, attempt + 1); }, 200);
      else cancel();
      return;
    }
    cancel();
    // Native Searchanise handlers normally open the panel first. Do not reopen it.
    if (autocomplete.select.visible()) return;
    // Use the vendor's existing handler, preserving query, language and mobile UI.
    field.triggerHandler(autocomplete.select.isMobileMode() ? 'mousedown' : 'click');
  }

  function activate(event) {
    var input = event.target;
    if (!input || input.id !== 'sidebar-searchanise-q-mobile' || input.disabled) return;
    if (event.type === 'pointerup' && (event.button !== 0 || event.isPrimary === false)) return;
    cancel();
    pending = input;
    // Pointerup precedes the vendor's touchend. Click also covers Safari/keyboard activation.
    open(input, 0);
  }

  document.addEventListener('pointerup', activate);
  document.addEventListener('click', activate);
  document.addEventListener('pointerdown', function (event) {
    if (pending && event.target !== pending) cancel();
  }, true);
  document.addEventListener('visibilitychange', function () { if (document.hidden) cancel(); });
}());
